import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { PersonVerySadIcon, PersonSadIcon, PersonNeutralIcon, PersonHappyIcon, PersonVeryHappyIcon, ThumbsUpIcon, ThumbsDownIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import Tooltip from '../Tooltip.js';

var _excluded = ["className", "data-testid", "display", "disabled", "error", "id", "onChange", "required", "value"];
var emotiveIcons = [{
  icon: PersonVerySadIcon,
  iconName: 'Terrible'
}, {
  icon: PersonSadIcon,
  iconName: 'Bad'
}, {
  icon: PersonNeutralIcon,
  iconName: 'Neutral'
}, {
  icon: PersonHappyIcon,
  iconName: 'Good'
}, {
  icon: PersonVeryHappyIcon,
  iconName: 'Excellent'
}];
var defaultIcon = [{
  icon: ThumbsUpIcon,
  iconName: 'Thumbs Up'
}, {
  icon: ThumbsDownIcon,
  iconName: 'Thumbs Down'
}];
var InputFeedback = function InputFeedback(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'],
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'simple' : _ref$display,
    disabled = _ref.disabled,
    error = _ref.error,
    id = _ref.id,
    onChange = _ref.onChange,
    required = _ref.required,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!id) {
    console.error("Hey Canvas User! A unique id is required for the feedback input.");
  }
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var _useState3 = useState(display === 'emotive' ? emotiveIcons : defaultIcon),
    _useState4 = _slicedToArray(_useState3, 2),
    icons = _useState4[0];
    _useState4[1];

  // this is needed to react to an external value change
  useEffect(function () {
    if (value != currentValue) {
      setCurrentValue(value);
    }
    /* eslint-disable */
  }, [value]);
  var finalClasses = classnames('C-Input--type-feedback', className, {
    isErrored: error
  });
  var handleChange = function handleChange(event) {
    setCurrentValue(Number(event.target.value));
    onChange && onChange(event);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: finalClasses
  }, otherProps, {
    "data-testid": dataTestId,
    "aria-label": ''
  }), icons.map(function (feedbackIcon, index) {
    var feedbackIndex = index + 1;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: "".concat(id, "_").concat(feedbackIcon.icon.name),
      key: "".concat(id, "_").concat(feedbackIcon.icon.name, "_input"),
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(feedbackIcon.icon.name, "_input") : null,
      name: id,
      value: feedbackIndex,
      type: "radio",
      disabled: disabled,
      required: required,
      "aria-required": required ? 'true' : 'false',
      "aria-label": feedbackIndex === currentValue ? "".concat(feedbackIcon.iconName, ", checked") : "".concat(feedbackIcon.iconName),
      onChange: handleChange,
      className: "C-Feedback__Input",
      checked: feedbackIndex === currentValue
    }), /*#__PURE__*/React.createElement(Tooltip, {
      className: "hc-mr-normal",
      location: disabled ? 'none' : 'bottom',
      content: feedbackIcon.iconName,
      key: "".concat(id, "_").concat(feedbackIcon.icon.name, "_tooltip")
    }, /*#__PURE__*/React.createElement("label", {
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(feedbackIcon.icon.name, "_label") : null,
      key: "".concat(id, "_").concat(feedbackIcon.icon.name, "_label"),
      htmlFor: "".concat(id, "_").concat(feedbackIcon.icon.name),
      className: "C-Feedback__Icon ".concat(disabled ? 'isDisabled' : '')
    }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
      icon: feedbackIcon.icon
    }))));
  }));
};
InputFeedback.displayName = 'Input.Feedback';

export { InputFeedback as default };
